const getters = {
  getEndorsement: (state) => state.endorsement,
  getEndorsements: (state) => state.endorsements,
  getEndorsementsMeta: (state) => state.endorsementsMeta,
  getPartners: (state) => state.partners,
  getProductCategories: (state) => state.productCategories,
};

export default getters;
